











































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import ContentType from "@/models/porposal/contentTeype.Model";
@Component
export default class ContentTypeAdd extends GenericAdd<ContentType> {
 
  constructor() {
    super();
    this.controller = "ContentTypes";
    this.model = new ContentType();
  }
}
